import { HubtypeFlow } from '@hubtype/data-access-models'
import { Icon } from '@hubtype/ui-react-web'

import { FALLBACK_FLOW, KNOWLEDGE_BASE_FLOW } from '../../constants'
import { useFlowBuilderSelector } from '../../reducer/hooks'
import { StyledFlowItemWithArrow } from './flow-selector-styles'

interface DefaultFlowItemProps {
  flow: HubtypeFlow
}

export const DefaultFlowItem = ({ flow }: DefaultFlowItemProps) => {
  const isKnowledgeBaseActive = useFlowBuilderSelector(
    ctx => ctx.state.isKnowledgeBaseActive
  )

  const hasDivision =
    (flow.id === KNOWLEDGE_BASE_FLOW.id && isKnowledgeBaseActive) ||
    (flow.id === FALLBACK_FLOW.id && !isKnowledgeBaseActive)

  return (
    <StyledFlowItemWithArrow
      $hasDivision={hasDivision}
      $hasBigMargin={flow.id === FALLBACK_FLOW.id && isKnowledgeBaseActive}
    >
      {[FALLBACK_FLOW.id, KNOWLEDGE_BASE_FLOW.id].includes(flow.id) && (
        <Icon icon='arrow-turn-down-right' />
      )}
      {flow.name}
    </StyledFlowItemWithArrow>
  )
}
